import { render, staticRenderFns } from "./ProductInvoiceReport.vue?vue&type=template&id=588af2d6&scoped=true&"
import script from "./ProductInvoiceReport.vue?vue&type=script&lang=js&"
export * from "./ProductInvoiceReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductInvoiceReport.vue?vue&type=style&index=0&id=588af2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588af2d6",
  null
  
)

export default component.exports